<template>
  <div>
    <label class="vform-editor-label section">Text</label>
    <div
        v-for="(key, index2) in Object.keys(element.label.dix)"
        v-if="$store.getters.getSelectedFormLanguage === key"
        :key="index2 + 1000000000 + forceReRenderKey"
        class="dflex"
    >
      <div class="col p-0">
        <input
            v-model="element.label.dix[key]"
            :placeholder="
                        key === 'Unknown'
                            ? placeholders.SHORT
                            : $t('vform.translationMessage', {
                                  key: key,
                                  content: element.label.dix['Unknown'],
                              })
                    "
            :title="element.label.dix['Unknown']"
            class="mb-1 form-text v-form-label form-text-dark"
            type="text"
        >
      </div>
    </div>
    <label class="vform-editor-label section">Options</label>
    <div class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">Size</label>
      </div>
      <div
          v-for="(headingCategory, index) in headingCategories"
          :key="index"
          :class="[
                    'vform-heading-cat-button clickable',
                    headingCategory === element.headingCategory ? 'active' : '',
                ]"
          @click="setCategory(headingCategory)"
      >
        <div class="size">{{ headingCategory.toUpperCase() }}</div>
      </div>
    </div>
    <div class="w-100"/>
    <template v-if="!element.emphasized">
      <label class="vform-editor-label section">Background Color</label>
      <color-picker-and-field
          :field-background-color="element.backgroundColor"
          @saveColor="(color) => {setItemColor('backgroundColor', color)}"
          @unsetColor="setItemColor('backgroundColor', null)"
      />

      <label class="vform-editor-label section">Font Color</label>
      <color-picker-and-field
          :field-background-color="element.fontColor"
          @saveColor="(color) => {setItemColor('fontColor', color)}"
          @unsetColor="setItemColor('fontColor', null)"
      />

      <div
          v-if="element.backgroundColor || element.fontColor"
          class="settings-button d-inline-block mt-2"
          @click="element.backgroundColor = null; element.fontColor = null;">
        {{ $t('resetColor') }}
      </div>
    </template>
    <div class="col row dflex mt-4">
      <div class="dflex">
        <label :for="'chkEmphasized' + $vnode.key" class="container vform-editor-body"
        >{{ $t("emphasized") }}
          <input
              :id="'chkEmphasized' + $vnode.key"
              v-model="element.emphasized"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {vFormControls, placeholders} from "@/enum";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
export default {
  name: "vFormHEADLINE",
  components: {
    ColorPickerAndField,
  },
  mixins: [vFormElementMixin],
  props: {
    element: {type: Object, required: true},
    stepNo: {type: Number, required: true},
    organizationId: {type: String, default: ""},
  },
  data() {
    return {
      forceReRenderKey: 0,
      editImage: "",
      vFormControls: vFormControls,
      placeholders: placeholders,
      headingCategories: ['h1', 'h2', 'h3'],
    };
  },
  beforeMount() {
    this.element.formElementType = vFormControls["HEADLINE"];
    if (!this.element.headingCategory) {
      this.$set(this.element, "headingCategory", "h3");
    }
  },
  methods: {
    setCategory(val) {
        this.$set(this.element, "headingCategory", val);
    },
    save() {
      this.$emit("save", this.element);
    },
  },
};
</script>

<style lang="scss" scoped>
.vform-heading-cat-button {
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 1px;
  margin-left: 1px;
  width: 25px;
  height: 25px;
  position: relative;
  color: #fff;
  transition: all 300ms ease;


  .size {
    vertical-align: baseline;
    font-size: 0.7rem;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin-top: 1px;
  }

  &.active, &:hover {
    background-color: var(--vform-editor-accent-color);
  }
}
</style>
